export const UserRoleType = {
  EMPLOYEE: 'employee',
  MANAGER: 'manager',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin',
  ACCOUNT_OWNER: 'account_owner',
};
